import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../input';
import Text from '../text';

/**
 * @param {
 *  objectName: string,
 *  formik: formik instance,
 *  translationPrefix: string
 * } props
 * @returns
 */
const EmailConsentForm = ({ objectName = 'emailConsent', formik, translationPrefix }) => {
  const { t } = useTranslation();

  const emailConsentFormikValues = formik.values?.[objectName] || {};

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-6">
      <div className="col-span-2">
        <Input
          name={'emailConsent'}
          id={'emailConsent'}
          paragraphLabel={t(`${translationPrefix}.emailConsent.label`)}
          type={'radio'}
          radioBGColor={'gray-30'}
          options={[
            {
              value: 'true',
              label: t(`${translationPrefix}.emailConsent.true`),
            },
            {
              value: 'false',
              label: t(`${translationPrefix}.emailConsent.false`),
            },
          ]}
          defaultValue={emailConsentFormikValues.emailConsent || 'true'}
          onChange={(value) => {
            formik.setFieldValue(objectName + '.emailConsent', value);
          }}
          error={
            formik.touched?.[objectName]?.emailConsent && formik.errors?.[objectName]?.emailConsent
          }
        />
      </div>

      <div className="col-span-2">
        <Input
          name={'studentsSafetyConsent'}
          id={'studentsSafetyConsent'}
          paragraphLabel={t(`${translationPrefix}.studentsSafetyConsent.label`)}
          type={'radio'}
          radioBGColor={'gray-30'}
          showCheckboxOnLeft={true}
          options={[
            {
              value: 'true',
              label: t(`${translationPrefix}.studentsSafetyConsent.true`),
            },
          ]}
          defaultValue={emailConsentFormikValues.studentsSafetyConsent || 'false'}
          onChange={(value) => {
            formik.setFieldValue(objectName + '.studentsSafetyConsent', value);
          }}
          error={
            formik.touched?.[objectName]?.studentsSafetyConsent &&
            formik.errors?.[objectName]?.studentsSafetyConsent
          }
        />
      </div>

      <div className="col-span-1">
        <Input
          name={'email'}
          id={'email'}
          label={t(`${translationPrefix}.emailOther.label`)}
          placeholder={t(`${translationPrefix}.emailOther.placeholder`)}
          inputClassName={'!bg-gray-30'}
          type={'email'}
          defaultValue={emailConsentFormikValues.email}
          onChange={(e) => {
            formik.setFieldValue(objectName + '.email', e.target.value);
          }}
          error={formik.touched?.[objectName]?.email && formik.errors?.[objectName]?.email}
        />
      </div>

      <div className="col-span-2">
        <Text type={'small'} text={t(`${translationPrefix}.emailConsent.paragraph`)} />
      </div>
    </div>
  );
};

export default EmailConsentForm;
